import {message, Tooltip} from 'antd';
import React, {useContext} from 'react';
import {getPermissions} from '../../../actions/userSlice';
import {isCohortExportable} from '../../../containers/CohortBuilder/PermissionsUtil';
import {Query} from '../../../containers/HealthcareUsageReport/types/CohortQuery';
import {useAppDispatch, useAppSelector} from '../../../hooks';
import {CohortAnalyser} from "../../cohort-navigation/icons/CohortAnalyser";
import styles from './ExportButton.module.scss'
import {AppDispatch} from "../../../configureStore";
import {markQueryRead} from "../../../containers/CohortBuilder/cohortBuilderSlice";
import {cohortAnalyserRoute, ProjectsPageContext, ProjectsPageContextType} from "../../../pages/ProjectsPageContext";

const openCohortAnalyser = (query: Query, classicCohortAnalyser: boolean, dispatch: AppDispatch) => {
    dispatch(markQueryRead(query.id)).then(() => {
        window.open(cohortAnalyserRoute(query, classicCohortAnalyser))
    })
}

const ExportQBButton = ({ query }: { query: Query }) => {
    const permissions = useAppSelector(getPermissions)
    const dispatch = useAppDispatch()
    const {classic} = useContext(ProjectsPageContext) as ProjectsPageContextType
    if (isCohortExportable(query)) {
        return (
            <Tooltip title="export to cohort analyzer">
                <span
                    className={styles['export-icon']}
                    onClick={e => {
                        e.stopPropagation();
                        if (permissions.cb && permissions.qb) {
                            openCohortAnalyser(query, classic, dispatch)
                        } else {
                            message.warn('You do not have access to Cohort Analyzer.')
                        }
                    }}
                >
                    <CohortAnalyser/>
                </span>
            </Tooltip>
        )
    }
    return null
}

export default ExportQBButton